import { render, staticRenderFns } from "./adminStaffDetail.vue?vue&type=template&id=cd9fb4e2&scoped=true"
import script from "./adminStaffDetail.vue?vue&type=script&lang=js"
export * from "./adminStaffDetail.vue?vue&type=script&lang=js"
import style0 from "./adminStaffDetail.vue?vue&type=style&index=0&id=cd9fb4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9fb4e2",
  null
  
)

export default component.exports